import { render } from "./AblaufKopf.vue?vue&type=template&id=dfa4d6e2&scoped=true"
import script from "./AblaufKopf.vue?vue&type=script&lang=js"
export * from "./AblaufKopf.vue?vue&type=script&lang=js"

import "./AblaufKopf.vue?vue&type=style&index=0&id=dfa4d6e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa4d6e2"]])

export default __exports__